import { render, staticRenderFns } from "./ApelidoInput.vue?vue&type=template&id=e75bf19c&"
import script from "./ApelidoInput.vue?vue&type=script&lang=js&"
export * from "./ApelidoInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports